import moment from "moment";
import { useEffect, useState } from "react";
import { Badge, Button, Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { ErrorLoading, PageLoading } from "../components/loading";
import { getPublicEvent } from "../resources/api/events";
import PublicEventLayout from "./public-event-layout";

const bool = value => value === true || value === 1 || value === "1";

const EventLanding = () => {
    const { shortCode } = useParams();
    const [event, setEvent] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        getPublicEvent(shortCode).then(({ event }) => setEvent(event)).catch(setError).finally(() => setLoaded(true));
    }, [shortCode]);

    if (!loaded) return <PageLoading>Loading event details...</PageLoading>;
    if (error || !event) return <ErrorLoading>{error || "Event not found."}</ErrorLoading>;

    const start = moment(`${event.start_date}${event.start_time ? ` ${event.start_time}` : ""}`);
    const end = (event.end_date || event.end_time) ? moment(`${event.end_date || event.start_date}${event.end_time ? ` ${event.end_time}` : ""}`) : null;
    const displayEvent = { ...event, start_date: start.format("DD MMM YYYY") };

    return (
        <PublicEventLayout event={displayEvent}>
            <h2 className="h5 mb-3">Event details</h2>
            {event.description && <p className="event-description mb-4">{event.description}</p>}
            <Row className="g-3 mb-4">
                <Col sm={6}><div className="event-detail"><i className="fas fa-location-dot" /><div><small>Location</small><strong>{event.location}</strong></div></div></Col>
                <Col sm={6}><div className="event-detail"><i className="far fa-calendar" /><div><small>Date</small><strong>{start.format("DD MMMM YYYY")}{end && !end.isSame(start, "day") ? ` – ${end.format("DD MMMM YYYY")}` : ""}</strong></div></div></Col>
                {(event.start_time || event.end_time) && <Col sm={6}><div className="event-detail"><i className="far fa-clock" /><div><small>Time</small><strong>{event.start_time ? start.format("h:mm A") : ""}{event.end_time ? ` – ${end.format("h:mm A")}` : ""}</strong></div></div></Col>}
            </Row>
            <div className="border-top pt-4">
                <Row className="g-3">
                    <Col sm={6}>
                        <div className="d-flex justify-content-between align-items-center mb-2"><strong>Registration</strong><Badge bg={bool(event.registrationOpen) ? "success" : "secondary"}>{bool(event.registrationOpen) ? "Open" : "Closed"}</Badge></div>
                        <Button as={Link} to={`/events/${shortCode}/registrations`} variant="success" className="w-100">Register for this event</Button>
                    </Col>
                    <Col sm={6}>
                        <div className="d-flex justify-content-between align-items-center mb-2"><strong>Feedback</strong><Badge bg={bool(event.feedbackOpen) ? "success" : "secondary"}>{bool(event.feedbackOpen) ? "Open" : "Closed"}</Badge></div>
                        <Button as={Link} to={`/events/${shortCode}/feedback`} variant="outline-success" className="w-100">Give feedback</Button>
                    </Col>
                </Row>
            </div>
        </PublicEventLayout>
    );
};

export default EventLanding;
